import { prose } from "../../lib/ui.ts";

export function Prose({ children, className }: { children: React.ReactNode; className?: string }) {
  const classes = className ? `${prose} ${className}` : prose;
  return <div className={classes}>{children}</div>;
}
